module.exports = require("bbcode-to-react");